import React, { useEffect } from "react";
import module from "./News.module.css";
import { Card, CardContent } from "@mui/material";
import { Link } from "react-router-dom";

const News = () => {
  useEffect(() => {
    document.body.style.backgroundColor = "#f5f5f5";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  const EachNews = ({ date, title, content, link = null }) => (
    <Card sx={{ maxWidth: "640px", margin: "auto", boxShadow: "unset", borderRadius: "8px", marginBottom: "16px" }}>
      <CardContent>
        <div>
          <span>{date}</span>
        </div>
        <div>
          <h2 className={module.cardTitle}>{title}</h2>
        </div>
        <div>
          <span className={module.cardContent}>{content}</span>
        </div>
        {link && (
          <div className={module.wrapLink}>
            <Link to={link.to} className={module.link}>
              {link.text}
            </Link>
          </div>
        )}
      </CardContent>
    </Card>
  );

  return (
    <div>
      <div className={module.top}>
        <h1 className={module.title}>お知らせ</h1>
      </div>
      <div className={module.contents}>
        <EachNews
          date={"2024.04.26"}
          title={"【再送】2023年10月、11月に報酬が発生したアンバサダー様へ"}
          content={
            <>
              平素よりナッシュアンバサダープログラムをご利用いただき誠にありがとうございます。<br />
              <br />
              2023年10月、11月に報酬が発生した方へのご案内です。 <br />
              ※上記期間以外に報酬が発生した方は対象ではありません。<br />
              <br />
              弊社システム不備発生により、今まで口座登録の翌金曜日に振込を行っておりましたが、<br />
              2024年5月以降、毎月末時点での登録口座情報に基づき、翌月末日にお振込を行う形へと変更いたします。<br />
              <br />
              多くのお客様にご協力いただいたことにより、振込対応をスムーズに進めることができたため、今回運用を変更することとなりました。<br />
              ご迷惑をおかけしたにもかかわらず、ご協力いただいた皆様、本当にありがとうございました。<br />
              <br />
              変更に伴いご不便をおかけすることもあるかもしれませんが、ご理解とご協力のほど、心よりお願い申し上げます。<br />
              口座登録がお済みでない方は、報酬設定よりご登録をお願いします。<br />
              <br />
              2024年4月中は、毎週日曜日24時までに口座登録（不備解消含む）いただいた方を対象に、2023年10月、11月紹介の未振込報酬分を翌金曜日に振込いたします。<br />
              ※2024年4月30日(月)までに口座設定した人は2024年5月2日(木)に振込いたします。<br />
              <br />
              2024年5月より、毎月末締め翌月末日にお振込となりますため、ご認識いただきますようお願いいたします。<br />
              <br />
              ご理解とご協力の程、よろしくお願いいたします。<br />
            </>
          }
        />
        <EachNews
          date={"2024.03.29"}
          title={"2023年10月、11月に報酬が発生したアンバサダー様へ"}
          content={
            <>
              平素よりナッシュアンバサダープログラムをご利用いただき誠にありがとうございます。<br />
              <br />
              2023年10月、11月に報酬が発生した方へのご案内です。<br />
              ※上記期間以外に報酬が発生した方は対象ではありません。<br />
              <br />
              弊社システム不備発生により、今まで口座登録の翌金曜日に振込を行っておりましたが、<br />
              2024年5月以降、毎月末時点での登録口座情報に基づき、翌月末日にお振込を行う形へと変更いたします。<br />
              <br />
              多くのお客様にご協力いただいたことにより、振込対応をスムーズに進めることができたため、今回運用を変更することとなりました。<br />
              ご迷惑をおかけしたにもかかわらず、ご協力いただいた皆様、本当にありがとうございました。<br />
              <br />
              変更に伴いご不便をおかけすることもあるかもしれませんが、ご理解とご協力のほど、心よりお願い申し上げます。<br />
              口座登録がお済みでない方は、報酬設定よりご登録をお願いします。<br />
              <br />
              2024年4月中は、毎週日曜日24時までに口座登録（不備解消含む）いただいた方を対象に、2023年10月、11月紹介の未振込報酬分を翌金曜日に振込いたします。<br />
              ※2024年4月30日(月)までに口座設定した人は2024年5月2日(木)に振込いたします。<br />
              <br />
              2024年5月より、毎月末締め翌月末日にお振込となりますため、ご認識いただきますようお願いいたします。<br />
              <br />
              ご理解とご協力の程、よろしくお願いいたします。<br />
            </>
          }
        />
        <EachNews
          date={"2023.10.30"}
          title={"よくあるご質問ページを公開しました"}
          content={
            <>
              平素よりナッシュアンバサダープログラムをご利用いただき誠にありがとうございます。
              <br />
              この度、皆さまよりお問合せいただいておりました主な内容について、下記のページに情報をとりまとめております。
              <br />
              必要に応じてご確認のほどよろしくお願いいたします。
            </>
          }
          link={{
            to: "/faq",
            text: "よくあるご質問",
          }}
        />
      </div>
    </div>
  );
};

export default News;
